(function () {
  function initSteps(root) {
    if (root.dataset.tddReady) return;
    root.dataset.tddReady = '1';
    var tabs = root.querySelectorAll('[data-tdd-tab]');
    var panels = root.querySelectorAll('[data-tdd-panel]');
    var bar = root.querySelector('[data-tdd-bar]');
    function showStep(i) {
      tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
      panels.forEach(function (p, n) {
        if (n === i) { p.hidden = false; p.classList.remove('tdd-pop'); void p.offsetWidth; p.classList.add('tdd-pop'); } else { p.hidden = true; }
      });
      if (bar) bar.style.width = ((i + 1) / tabs.length * 100) + '%';
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { showStep(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[n].focus(); showStep(n);
        }
      });
    });
    root.querySelectorAll('[data-tdd-next]').forEach(function (b) {
      b.addEventListener('click', function () { showStep(Number(b.dataset.tddNext)); });
    });
    root.querySelectorAll('[data-tdd-level]').forEach(function (b) {
      b.addEventListener('click', function () {
        var lv = b.dataset.tddLevel;
        root.querySelectorAll('[data-tdd-level]').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.tddLevel === lv ? 'true' : 'false'); });
        root.querySelectorAll('[data-tdd-level-panel]').forEach(function (p) { p.hidden = p.dataset.tddLevelPanel !== lv; });
      });
    });
    root.querySelectorAll('[data-tdd-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        var blank = b.dataset.tddView === 'blank';
        root.classList.toggle('is-blank', blank);
        root.querySelectorAll('[data-tdd-view]').forEach(function (x) { x.setAttribute('aria-pressed', (x.dataset.tddView === 'blank') === blank ? 'true' : 'false'); });
      });
    });
  }
  var mq = window.matchMedia('(max-width: 749px)');
  function initMobile() {
    var small = mq.matches;
    document.querySelectorAll('.tdd-more').forEach(function (d) {
      d.classList.toggle('is-collapsible', small);
      if (small) { d.removeAttribute('open'); } else { d.setAttribute('open', ''); }
    });
    document.querySelectorAll('.tdd-night__grid, .tdd-hss__tiers').forEach(function (g) {
      var next = g.nextElementSibling;
      if (next && next.classList.contains('tdd-swipe-hint')) return;
      if (g.children.length < 2) return;
      var p = document.createElement('p');
      p.className = 'tdd-swipe-hint';
      p.setAttribute('aria-hidden', 'true');
      p.textContent = 'Swipe to compare →';
      g.insertAdjacentElement('afterend', p);
    });
  }
  function initAll() { document.querySelectorAll('[data-tdd-steps]').forEach(initSteps); initMobile(); }
  if (mq.addEventListener) mq.addEventListener('change', initMobile);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
